import '../assets/NcCheckboxRadioSwitch-DWtZ7faS.css';
import { r as register } from "./_l10n-B4dEPXsr.mjs";
register();
